import { atom, useRecoilState, useResetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

const firstLogin = atom<boolean>({
  key: '@app/firstLogin',
  default: false,
  effects: [localStorageEffect('@app/firstLogin')],
})

export function useFirstLogin() {
  const [firstLoginState, setFirstLoginState] = useRecoilState(firstLogin)
  const resetFirstLoginState = useResetRecoilState(firstLogin)

  return {
    resetFirstLoginState,
    setFirstLoginState,
    firstLoginState,
  }
}
